import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Styled } from './styles';
import type { HeadingProps, HeadingVariant } from './types';

export { headingVariants } from './types';
export type { HeadingProps, HeadingVariant } from './types';

export const htmlTagByVariant: Record<HeadingVariant, keyof React.JSX.IntrinsicElements> = {
  'heading-1': 'h1',
  'heading-2': 'h2',
  'heading-3': 'h3',
  'heading-4': 'h4',
  'heading-4-light': 'h4',
  'heading-5': 'h5',
  'heading-5-light': 'h5',
  subtitle: 'h6',
  'subtitle-light': 'h6',
};
type DivProps = Omit<ComponentPropsWithoutRef<'div'>, keyof HeadingProps>;

type Props = DivProps & HeadingProps;

export const Heading = forwardRef<HTMLDivElement, Props>(({ as, color, display = 'block', variant, ...props }, ref) => (
  <Styled.Div
    {...props}
    as={as ?? htmlTagByVariant[variant]}
    color={color}
    display={display}
    ref={ref}
    variant={variant}
  />
));
Heading.displayName = 'Heading';
